let external: { [prop: string]: string } = {};

/**
 * 为所有的XMLHttpRequest添加请求头
 * @param header
 */
export function add_xml_http_request_header(header: {
  [prop: string]: string;
}) {
  external = { ...external, ...header };
}

/**
 * 为所有的XMLHttpRequest删除请求头
 * @param headerKeys
 */
export function remove_xml_http_request_header(keys: string[]) {
  const map: { [prop: string]: string } = {};
  for (const key in external) {
    if (!keys.includes(key)) {
      map[key] = external[key];
    }
  }
  external = map;
}

const send = XMLHttpRequest.prototype.send;
XMLHttpRequest.prototype.send = function (...args: any[]) {
  for (const key in external) {
    this.setRequestHeader(key, external[key]);
  }
  send.call(this, ...args);
};

